<template lang="pug">
	DxFilterBuilder.app-core--filter-builder(ref="filterBuilder" :fields="fields", :value.sync="innerValue")
</template>

<script>
	import DxFilterBuilder from 'devextreme-vue/filter-builder';

	export default {
		name: 'app-core--filter-builder',
		components: { DxFilterBuilder },
		model: {
			prop: 'value',
			event: 'change'
		},
		props: ['fields', 'value'],
		data() {
			return {
				innerValue: this.value
			};
		},
		mounted() {
			if (__DEBUG__)
				window.filterBuilder = this;
			
			this.checkIsValid();
		},
		watch: {
			'innerValue'(v) {
				if (this.$refs.filterBuilder && this.innerValue) {
					var filterExp = this.$refs.filterBuilder.instance.getFilterExpression();
					if (__DEBUG__)
						console.debug('currentEventRule.criteria change', { v, filterExp });
					if (JSON.stringify(v) !== JSON.stringify(filterExp)) {
						this.innerValue = filterExp;
					}
				}
				this.checkIsValid();
				this.$emit('change', this.innerValue);
			}
		},
		methods: {
			checkIsValid() {
				try {
					this.$refs.filterBuilder.instance.getFilterExpression();
				} catch {
					this.innerValue = null;
				}
			}
		}
	};
</script>
<style lang='scss'>
	.app-core--filter-builder {
		@import "main/themes/generated/variables.base.scss";

		&.dx-filterbuilder {
			background-color: transparent !important;
		}
	}
</style>
